import { render, staticRenderFns } from "./KpisByMunicipioMap.vue?vue&type=template&id=5503791c&"
import script from "./KpisByMunicipioMap.vue?vue&type=script&lang=js&"
export * from "./KpisByMunicipioMap.vue?vue&type=script&lang=js&"
import style0 from "./KpisByMunicipioMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VProgressCircular,VSelect})
